export const licenseagreementConstants = {
    GETALL_REQUEST: 'LICENSEAGREEMENT_GETALL_REQUEST',
    GETALL_SUCCESS: 'LICENSEAGREEMENT_GETALL_SUCCESS',
    GETALL_FAILURE: 'LICENSEAGREEMENT_GETALL_FAILURE',

    DELETE_REQUEST: 'LICENSEAGREEMENT_DELETE_REQUEST',
    DELETE_SUCCESS: 'LICENSEAGREEMENT_DELETE_SUCCESS',
    DELETE_FAILURE: 'LICENSEAGREEMENT_DELETE_FAILURE'
};
